import React, { useEffect, useState } from 'react';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { List } from './List';
import { ONLINE_STORE_ID } from '../../constants';
import { isAuthenticated, isLoggedIn } from '../../helpers';

export const ListContainer = ({ ...props }) => {

  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const isGuest = typeof window !== 'undefined' && !isLoggedIn();
    if (isGuest) {
      const signInURL = typeof window !== 'undefined'
      && `https://${window.location.hostname}/auth/view/signin?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`;
      window.location.href = signInURL;
    } else {
      setAuthenticated(isAuthenticated());
    }
  }, []);

  const disableSSR = typeof window !== 'undefined' && window.DISABLE_SSR;
  const varnish = !disableSSR;
  const store = useStore({ varnish, online: false });
  const { storeId, membershipInformation, storeZip, isLocalized } = store;

  const { isCustomerIdentified = false } = useThdCustomer();

  const isMounted = ({ mounted }) => {
    if (storeId === ONLINE_STORE_ID && mounted) {
      return false;
    }

    if (membershipInformation?.error) {
      return mounted;
    }

    if (membershipInformation?.loading) {
      return false;
    }

    return mounted;
  };

  const additionalSearchParams = {};
  if (storeZip) {
    additionalSearchParams.deliveryZip = storeZip;
  }

  const isBrandPricingPolicyCompliant = isLocalized ? isCustomerIdentified : false;

  const defaultVariables = {
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership,
    skipInstallServices: true,
    skipFavoriteCount: true,
    skipKPF: true,
    skipSpecificationGroup: false,
    skipSubscribeAndSave: true,
    zipCode: undefined,
    additionalSearchParams,
    isBrandPricingPolicyCompliant
  };

  return (
    <QueryProvider
      defaultVariables={defaultVariables}
      mounted={isMounted}
      cacheKey="list-page-container"
    >
      <List
        defaultVariables={defaultVariables}
        authenticated={authenticated}
      />
    </QueryProvider>
  );
};

ListContainer.dataModel = extend(List);

ListContainer.propTypes = {
};

ListContainer.defaultProps = {
};
